// Sectors listed in the sidebar context dropdown.
// Set `available: true` once a sector has its own sidebar and dashboards.
const sectors = [
  {
    id: "property",
    label: "Property",
    description: "Commercial & mixed-use assets",
    icon: "bi bi-buildings",
    available: true
  },
  {
    id: "mining",
    label: "Mining",
    description: "Mine sites & operations",
    icon: "bi bi-minecart-loaded",
    available: true
  },
  {
    id: "visible-social-impact",
    label: "Visible Social Impact",
    description: "Community & social programmes",
    icon: "bi bi-people-fill",
    available: false
  },
  {
    id: "other",
    label: "Other",
    description: "Additional sectors",
    icon: "bi bi-grid-3x3-gap-fill",
    available: false
  }
];

export default function get_sectors() {
  return sectors;
}
